export const COMPANY_USERS_TAG_NAME = 'tm-company-users';
export const COMPANY_USER_STATUS_CONFIRMATION_TAG_NAME = 'user-status-confirmation';
export const COMPANY_USER_LIST_TAG_NAME = 'tm-company-user-list';
